import fetchModel from "@/mixin/store/api/fetchModel";
import changeModel from "../../mixin/store/api/changeModel";
import pushModel from "../../mixin/store/api/pushModel";

export default {
    actions: {
        fetchUser(context) {
            if (context.state.user.isNeedFetch) {
                return fetchModel(context, 'users/about_me', null, 'updateUser')
            }
        },
        fetchUpdateNumber(context, data) {
            return changeModel(context, 'people/' + data.id, {telephone: data.telephone}, null)
        },
        fetchRequestResetPassword(context, data) {
            return pushModel(context, 'users/request_reset_password', data)
        },
        fetchResetPassword(context, data) {
            return pushModel(context, 'users/reset_password', data)
        },
        fetchCheckResetToken(context, data) {
            return pushModel(context, 'users/check_reset_token', data)
        }
    },
    mutations: {
        updateUser(state, model) {
            state.user = model
            state.user.isNeedFetch = false
        },
        clearRoles(state) {
            state.user.roles = []
        }
    },
    state: {
        user: {
            "id": null,
            "email": null,
            "roles": [],
            "person": {
                "id": null,
                "familyName": null,
                "givenName": null,
                "employeePositions": [
                    // {
                    //     "@context": "string",
                    //     "@id": "string",
                    //     "@type": "string",
                    //     "id": 0,
                    //     "name": "string"
                    // }
                ],
                "employeeInformation": null,
                "company": {
                    "id": null,
                    "isActive": null,
                    "createdAt": null,
                    "plans": [],
                    baseCurrency: null,
                    tax: null,
                    isTaxInPrice: true,
                    name: null
                }
            },
            isNeedFetch: true
        },
    },
    getters: {
        getUser(state) {
            return state.user
        },
        getUserCompany(state, getters) {
            return getters.getUser.person.company
        },
        getUserCompanyName(state, getters) {
            return getters.getUser.person.company.name
        },
        getUserPhone(state, getters) {
            return getters.getUser.person.telephone
        },
        getUserPerson(state, getters) {
            return getters.getUser.person
        },
        getUserCompanyIsActive(state, getters) {
            return getters.getUserCompany.isActive
        },
        getUserCompanyId(state, getters) {
            return getters.getUserCompany.id
        },
        getUserCompanyIdAt(state, getters) {
            return getters.getUserCompany['@id']
        },
        getUserRoles(state, getters) {
            return getters.getUser.roles
        },
        getUserCompanyCreatedAt(state, getters) {
            return getters.getUser.person.company.createdAt
        },
        isCeo(state, getters) {
            return getters.getUser.roles.includes('ROLE_CEO')
        }
    },
}
